import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Avatar,
  CircularProgress,
  TablePagination,
  IconButton,  Menu,MenuItem,
  Grid,
  ListItemIcon,
  ListItemText,TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import Swal from 'sweetalert2'; // Import Swal
import { GlobalStyles } from "@mui/system";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../../AuthProvider";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main,
  fontSize: "1.5rem",
  textAlign: "center",
  fontWeight: "bold",
}));


const baseUrl = process.env.REACT_APP_API_BASE_URL;
function Employee() {
  const [employees, setEmployees] = useState([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const {oId,pId}=useAuth()
  const [searchQuery, setSearchQuery] = useState("");


   const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };





  useEffect(() => {
    fetchEmployees();
  }, []);

  // Fetch employees
  const fetchEmployees = async () => {
    try {
      setLoader(true);
      const response = await fetch(`${baseUrl}/api/employee/getAll/${oId}/${pId}`);
      const data = await response.json();
      const employeesWithImages = data.map((employee) => ({
        ...employee,
        profilePic: `data:image/jpeg;base64,${employee.profilePic}`,
      }));
      setEmployees(employeesWithImages);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };

  // Handle delete with swal confirmation
  const handleDelete = async (employeeId, employeeName) => {
    // Show confirmation dialog with swal
    Swal.fire({
      title: `Are you sure you want to delete?`,
      // text: `Employee: ${employeeName} Permanently`,
        html: `Employee: <b style="color:red;">${employeeName}</b> Permanently`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${baseUrl}/api/employee/delete/${employeeId}`, {
            method: 'DELETE',
          });
          if (response.ok) {
            // Swal.fire("Employee Deleted!", `${employeeName} has been deleted.`, "success");
            toast.success(`${employeeName} has been deleted successfully!`, {
              position:"top-right",
              autoClose: 1000,
            });
            // Remove the employee from the state immutably
            setEmployees((prevEmployees) =>
              prevEmployees.filter((employee) => employee.employeeId !== employeeId)
            );
          } else {
            console.error("Error deleting employee:", response.statusText);
            // Swal.fire("Error!", "An error occurred while deleting.", "error");
            toast.error("Existing Records are their For this employee,So We Can't Delete", {
              position: "top-right",
              autoClose: 1000,
            });
          }
        } catch (error) {
          console.error("Error deleting employee:", error);
          // Swal.fire("Error!", "An error occurred while deleting.", "error");
          toast.error("There was an issue while deleting", {
            position: "top-right",
            autoClose: 1000,
          });
        }
      }
    });
  };

  const handleClickOpen = (employee) => {
    // navigate(`/employeeDetails/${employee.empId}`);
    // navigate(`/EmployeeDetails/${employee.employeeId}`);
    navigate(`/EmployeeDetails/${employee.empId}/${employee.employeeId}`);
  };

  const handleNavigateToOtherComponent = () => {
    // navigate("/EmployeeRegForm");
    navigate("/EmployeeRegForm");
  };



  const filteredResults = employees.filter((item) => {
    const firstName = item.firstName?.toLowerCase() || ""; // Handle undefined case
    const lastName = item.lastName?.toLowerCase() || ""; // Corrected case
    const fullName = `${firstName} ${lastName}`.trim(); // Combine names
    const contactNumber = item.contactNumber1 ? item.contactNumber1.toString() : ""; // Ensure string
    const employeeId = item.employeeId ? item.employeeId.toString() : ""; // Ensure string
  
    return (
      fullName.includes(searchQuery.toLowerCase()) || // Search in full name
      employeeId.includes(searchQuery) || // Search in full name
      contactNumber.includes(searchQuery) // Search in contact number
    );
  });




  const exportToExcel = () => {
    const processedData = employees.map(
      ({
        empId,
        prefix,
        firstName,
        lastName,
        employeeId,
        emailId,
        contactNumber1,
        gender,
        dateofBirth,
        bloodGroup,
        nationality,
        workEmail,
        joiningDate,
        hno,
        city,
        state,
        aadharNumber,
        panNumber,
        passportNo,
        maritalStatus,
        contactNumber2,
        uan,
        fatherName,
        motherName,
        previousSchoolName,
        previousExperience,
        department,
        designation,
        currentCtc,
        higherQualification,
        bankName,
        bankAccount,
        ifscCode,
        bankBranch,
        bonus,
        otherEarnings,
        workBasisPay,
        overTime,
        incentive,
        tax,
        pf,
        loanRepayment,
        earlyLeavingFine,
        lateComingFine,
        otherDeductions,
        hra,
        dra,
        petrolAllowance,
        foodAllowance,
        basicSalary,
        workStatus,
        verified
      }) => ({
        EmployeeID: employeeId,
        Prefix: prefix,
        Name: `${firstName} ${lastName}`,
        Gender: gender,
        DateOfBirth: dateofBirth,
        BloodGroup: bloodGroup,
        Nationality: nationality,
        WorkEmail: workEmail,
        JoiningDate: joiningDate,
        Address: `${hno}, ${city}, ${state}`,
        AadharNumber: aadharNumber,
        PanNumber: panNumber,
        PassportNo: passportNo,
        MaritalStatus: maritalStatus,
        Contact1: contactNumber1,
        Contact2: contactNumber2,
        UAN: uan,
        FatherName: fatherName,
        MotherName: motherName,
        PreviousSchool: previousSchoolName,
        PreviousExperience: previousExperience,
        Department: department,
        Designation: designation,
        CurrentCTC: currentCtc,
        HigherQualification: higherQualification,
        BankName: bankName,
        BankAccount: bankAccount,
        IFSCCode: ifscCode,
        BankBranch: bankBranch,
        Bonus: bonus,
        OtherEarnings: otherEarnings,
        WorkBasisPay: workBasisPay,
        OverTime: overTime,
        Incentive: incentive,
        Tax: tax,
        PF: pf,
        LoanRepayment: loanRepayment,
        EarlyLeavingFine: earlyLeavingFine,
        LateComingFine: lateComingFine,
        OtherDeductions: otherDeductions,
        HRA: hra,
        DRA: dra,
        PetrolAllowance: petrolAllowance,
        FoodAllowance: foodAllowance,
        BasicSalary: basicSalary,
        WorkStatus: workStatus,
        Verified: verified
      })
    );
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees_List");
  
    worksheet.columns = Object.keys(processedData[0]).map((key) => ({
      header: key.replace(/([A-Z])/g, " $1").trim(),
      key,
      width: 20,
    }));
  
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });
  
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" },
      };
    });
  
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Employees_List.xlsx";
      link.click();
    });
  
    handleExportClose();
  };
  

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Employees List", 10, 8);
  
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 10, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 35, 16);
  
    // Table
    doc.autoTable({
      startY: 20,
      head: [
        [
          "S.No",
          "Employee ID",
          "Name",
          "Gender",
          "Date of Birth",
          "Contact",
          "Email",
          "Father Name",
          "Joining Date",
        ],
      ],
      body: employees.map((row, index) => [
        index + 1,
        row.employeeId,
        `${row.firstName} ${row.lastName}`,
        row.gender,
        row.dateofBirth,
        row.contactNumber1,
        row.emailId || "N/A",
        row.fatherName || "N/A",
        row.joiningDate,
      ]),
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
      margin: { left: 3, right: 3 }, // ✅ remove left/right margin
       tableWidth: "auto", // table spans full page width
    });
  
    doc.save("Employees_List.pdf");
    handleExportClose();
  };
  

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(employees, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `Employees_List.json`;
    link.click();
    handleExportClose();
  };
  
  return (
   
    <Box>
       
      <Box mt={8} marginLeft={2} marginRight={2}>
      
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",width:'100%'
          }}
         
        >
         

          {/* <Title variant="h5" sx={{ marginTop: 3 }}>Employees Management</Title> */}
          <Box display="flex" alignItems="center" sx={{marginBottom:1,marginTop:'10PX'}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Employees Management
                              </Typography>
                            </Box>

          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
                <TextField
      label="Search by Emp Id or Name or Mobile No"
      variant="outlined"
      size="small"
      style={{width:'250px'}}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      fullWidth
    />
              <Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#3C3972" },
                    fontWeight: "bold",
                    marginRight: 2,
                    marginBottom: 2,
                  }}
                  onClick={handleNavigateToOtherComponent}
                >
                  Add New Employee
                </Button>

                {/* <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#3C3972" },
                    
                    marginBottom: 2,
                  }}
                  onClick={handleExport}
                >
                  <ScreenShareOutlinedIcon sx={{ marginRight: 1 }} />{" "}
                 
                  Export
                </Button> */}


             <Button
                variant="contained"
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3C3972",
                  fontWeight:'bold',
                  color: "#fff",
                  "&:hover": { backgroundColor: "#3C3972" },
                  
                  marginBottom: 2,
                }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem>

                {/* <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    color: "#388e3c",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f5e9",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#6a1b9a" }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                  />
                </MenuItem> */}
              </Menu>












              </Box>
            </Box>


            <GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
            <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }} className="custom-sidebar-scrollbar">
              <Table stickyHeader>
                <TableHead >
                  <TableRow>
                  <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>S.No</TableCell>
                    {/* <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Thumbnail</TableCell> */}
                    <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Employee Id</TableCell>
                    <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Employee Name</TableCell>
                    <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Mobile</TableCell>
                    {/* <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>E-mail</TableCell> */}
                    <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Action</TableCell>
                    <TableCell sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                      fontSize:'14px'
                    }}>Delete</TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                  {loader ? (
                                                <TableRow>
                                                  <TableCell
                                                                       colSpan={8}
                                                                       style={{ textAlign: "center", padding: "20px" }}
                                                                     >
                                                                       <Box
                                                                         display="flex"
                                                                         flexDirection="column"
                                                                         alignItems="center"
                                                                       >
                                                                         <CircularProgress />
                                                                         <Typography variant="body2" sx={{ mt: 1 }}>
                                                                           Loading Data...
                                                                         </Typography>
                                                                       </Box>
                                                                     </TableCell>
                                                </TableRow>
                                              ) : filteredResults.length === 0 ? (
                                                <TableRow>
                                                  <TableCell colSpan={8} style={{ textAlign: "center", padding: "20px" }}>
                                                    No data available
                                                  </TableCell>
                                                </TableRow>
                                              ) : (
                                                filteredResults.map((employee,index) => (
                        <TableRow
                        key={employee.id}
                        style={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white"; // Default color
                        }}
                      >
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px", // Reduced padding
                            textAlign: "center",
                            maxWidth: "50px", // Reduce width
                            minWidth: "50px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                      
                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px", // Reduce width
                            minWidth: "50px",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Avatar alt={employee.firstName} src={employee.profilePic} sx={{ width: 20, height: 20 }} />
                          </Box>
                        </TableCell> */}
                      
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px", // Reduce width
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.employeeId}
                        </TableCell>
                      
                         <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "2px",
                          textAlign: "center",
                          maxWidth: "80px",
                          minWidth: "80px",
                        }}
                      >
                        <Box
                          sx={{
                            whiteSpace: "normal",       // Allow wrapping
                            wordBreak: "break-word",    // Break long words
                            overflowWrap: "break-word",
                            fontSize: "13px",
                          }}
                        >
                          {employee.firstName} {employee.lastName}
                        </Box>
                      </TableCell>
                      
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "100px",
                            minWidth: "100px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.contactNumber1}
                        </TableCell>
                      
                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "150px",
                            minWidth: "150px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {employee.emailId || "N/A"}
                        </TableCell> */}
                      
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#1976d2",
                              margin: "4px",
                              fontSize: "0.6rem", // Reduce button font size
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                            onClick={() => handleClickOpen(employee)}
                          >
                            View
                          </Button>
                        </TableCell>
                      
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px",
                            minWidth: "50px",
                          }}
                        >
                          <IconButton
                            aria-label="delete"
                            onClick={() => handleDelete(employee.employeeId, `${employee.firstName} ${employee.lastName}`)}
                            sx={{ color: "red", padding: "2px" }}
                          >
                            <DeleteIcon fontSize="small" /> {/* Reduce icon size */}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      
                    ))
                    )}
                  
                  </TableBody>
               
              </Table>
            </TableContainer>

            {/* Pagination */}
            {/* <TablePagination
              component="div"
              count={employees.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </CardContent>
         
        </Card>
        
      </Box>
      <ToastContainer/>
    </Box>
    
  );
}

export default Employee;
